import appAxios from "../../utils/appAxios"
export default {
    namespaced: true,
    state: {
        actonDetail: {
            id: 0,
            axtionNo: 0,
            questionText: null,
            actionTaken: null,
            actionStatus: null,
            actionDate: null,
            responsiblePerson: null,
            departmentName: null
        },
        actionDetailList: [],
        actionStatusList: [],
        actionLocationList: [],
        loading: false,
        totalItemsCount: 0

    },

    getters: {
        _getActionDetail: (state) => {
            return state.actionDetailList;
        },
        _getActionStatus: (state) => {
            return state.actionStatusList;
        },
        _getTotalRecords: (state) => {
            return state.totalItemsCount
        },
        _getLoading: (state) => {
            return state.loading
        },
        _getActionLocation: (state) => {
            return state.actionLocationList
        }

    },
    mutations:
    {
        SET_ACTION_DETAIL: (state, Data) => {
            state.actionDetailList = []
            state.totalItemsCount = Data.TotalItemsCount
            if (Data.ListItems.length > 0) {
                Data.ListItems.forEach(item => {
                    state.actionDetailList.push(item)
                });
            }
            state.loading = false
        },
    },
    actions: {
        async GET_ACTION_DETAIL({ commit, state }, payload) {
            state.loading = true
            await appAxios.post("/admin/Action/GetAuditActions", payload).then(response => {
                commit("SET_ACTION_DETAIL", response.data.Data)
            }).catch(() => state.loading = false)
        },

        async ADD_ACTION(context, payload) {
            await appAxios.post("/admin/Action/AddAction", payload)
        },

        async GET_ACTION_STATUSES({ state }) {
            await appAxios.get("/Common/GetActionStatuses").then(response => {
                if (response.data.Success) {
                    state.actionStatusList = response.data.Data
                }
            }
            )
        },
        async APPROVE_ACTIONS({ dispatch }, payload) {
            await appAxios.post("admin/Action/ApproveActions", payload[0]).then(response => {
                if (response.data.Success) {
                    dispatch("GET_ACTION_DETAIL", payload[1])

                }
            })
        },
        async REJECT_ACTIONS({ dispatch }, payload) {
            await appAxios.post("admin/Action/RejectActions", payload[0]).then(response => {
                if (response.data.Success) {
                    dispatch("GET_ACTION_DETAIL", payload[1])

                }
            })
        },
        async SEND_FOR_APPROVAL({ dispatch }, payload) {
            await appAxios.post("admin/Action/SendForApproval", payload[0]).then(response => {
                if (response.data.Success) {
                    dispatch("GET_ACTION_DETAIL", payload[1])

                }
            })
        },

        async GET_LOCATION_BY_USER({ state }) {
            await appAxios.get("/Common/GetLocationsByUser").then(response => {
                if (response.data.Success) {
                    state.actionLocationList = response.data.Data
                }
            }
            )
        },


    }


}